<template>
    <router-view />
    <df-ui2-banner />
    <df-global-loading />
</template>

<script>

</script>

<style lang="scss">
@use "@/assets/ui2/main.scss" as *;

</style>
